import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

export const createBerth = (payload, token) => {
  let data = JSON.stringify(payload);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/createberth`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in create berth: ", error);
      return error.response?.data || { status: false, message: "Network error" };
    });

  return res;
};

export const getBerthsByUserId = (id, token) => {
  let config = {
    method: "get",
    url: `${baseUrl}/api/user/getberthbyuserid/${id}`,
    headers: {
      token: token,
    },
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in getBerthsByUserId: ", error);
      return error.response?.data || { status: false, message: "Network error" };
    });

  return res;
};

export const deleteBerthById = (id, token) => {

  let config = {
    method: 'delete',
    url: `${baseUrl}/api/user/deleteberth?berthId=${id}`,
    headers: {
      'token': token
    }
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in delete berth: ", error);
      return error.response?.data || { status: false, message: "Network error" }
    });
  return res
}

export const updateBerthById = (payload, token) => {
  let data = JSON.stringify(payload);

  let config = {
    method: 'put',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/updateberth`,
    headers: {
      'token': token,
      'Content-Type': 'application/json'
    },
    data: data
  };

  const res = axios.request(config)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log("error in updateBerthById: ", error);
      return error?.response?.data
    });
  return res
}

export const getAvailableBerths = (token, availableFor, lat, long, dist) => {

  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/getavailableberthtoswaporrent${dist ? `?availableFor=${availableFor}&lat=${lat}&long=${long}&dist=${dist}` : ""}`,
    headers: {
      'token': token
    }
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in available berths: ", error);
      return error.response?.data || { status: false, message: "Network error" }
    });
  return res;
}

export const getAvailableBerthsPublic = () => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/getavailableberthtoswaporrentpublic`,
    headers: {}
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in public available berths: ", error);
      return error?.response?.data || null
    });
  return res;
}

export const getAllRequestsToOwnBerths = (token) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/transaction/requestrecivedfromotheruser`,
    headers: {
      'token': token
    }
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in getAllRequestsToOwnBerths: ", error);
      return error.response?.data || { status: false, message: "Network error" }
    });
  return res
}

export const getAllOwnRequestsToOthersBerths = (token) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/transaction/requestsentbyuser`,
    headers: {
      'token': token
    }
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in getAllOwnRequestsToOthersBerths: ", error);
      return error.response?.data || { status: false, message: "Network error" }
    });
  return res
}

export const getBerthOwnerCommissionValue = (token, berthOwnerId) => {
  let config = {
    method: 'get',
    url: `${baseUrl}/api/user/getberthownercommissionvalue/${berthOwnerId}`,
    headers: {
      'token': token,
      'Content-Type': 'application/json'
    }
  }

  const res = axios.request(config)
    .then((response) => {
      return response.data.data;
    }).catch(err => {
      console.error("Error in getBerthOwnerCommissionValue: ", err);
      return err.response?.data ?? null;
    })

  return res;
}

export const sendSwapOrHireRequest = (payload, token) => {
  let data = JSON.stringify(payload);

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/transaction/rentorswap`,
    headers: {
      'token': token,
      'Content-Type': 'application/json'
    },
    data: data
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in sendSwapOrHireRequest: ", error);
      return error.response?.data || { status: false, message: "Network error" }
    });
  return res
}

export const uploadBerthImage = (image, berthId, token) => {
  let data = new FormData();
  data.append("file_upload", image);
  data.append("folder", "berth");

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/uploadberthimage?folder=berth&id=${berthId}`,
    headers: {
      token: token,
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in berth image upload: ", error);
      return error.response?.data || { status: false, message: "Network error" };
    });

  return res;
};

export const updateBerthStatus = (type, id, token, rejectionMessage = null) => {
  let data = JSON.stringify({
    type: type,
    cancellationReason: rejectionMessage
  });

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/transaction/changestatus/${id}`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in updateBerthStatus: ", error);
      return error.response?.data || { status: false, message: "Network error" };
    });

  return res;
};

export const getBerthById = (id, token) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/getberthbyid/${id}`,
    headers: {
      token: token,
    },
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in get berth: ", error);
      return error.response?.data || { status: false, message: "Network error" };
    });
  return res;
};

export const getPastBerths = (token) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/transaction/getpastberths`,
    headers: {
      token: token,
    },
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in get past berths: ", error);
      return error.response?.data || { status: false, message: "Network error" };
    });
  return res;
};